import { LINKS } from "./constants";

export enum Environment {
  LOCAL = "LOCAL",
  DEV = "DEV",
  OFFICIAL = "OFFICIAL"
}

export const getLiteUrl = () => {
  if (getEnv() !== Environment.OFFICIAL) {
    return LINKS.LITE_MSP.DEV;
  }
  return LINKS.LITE_MSP.OFFICIAL;
}

export function getEnv(): Environment {
  /* local */
  if (process.env.NODE_ENV === 'development') return Environment.LOCAL
  /* online */
  const { host, hostname } = window.location;
  // A production build served from localhost is not production: without this a
  // locally served bundle resolves login_server.prod and the prod client id.
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]") {
    return Environment.DEV;
  }
  return host.endsWith("dd.firewalla.net") ? Environment.DEV : Environment.OFFICIAL;
}